module.exports = __webpack_public_path__ + "media/preview/workshop@1x-fd96cc55.png";